import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import Home from 'pages/home';
import Detail from 'pages/detail';
import Search from 'pages/search';
import Admission from 'pages/admission';
import DownloadPoundBill from 'pages/downloadPoundBill';
import Privacy from 'pages/privacy';

const getRouter = () => (
    <Router>
            <Switch>
                    <Route exact path='/' component={Home}></Route>
                    <Route path='/detail' component={Detail}></Route>
                    <Route path='/search' component={Search}></Route>
                    <Route path='/admission' component={Admission}></Route>
                    <Route path='/downloadPoundBill' component={DownloadPoundBill}></Route>
                    <Route path='/privacy' component={Privacy}></Route>
            </Switch>
    </Router>
);

export default getRouter;

